module.exports = __webpack_public_path__ + "img/reports-availability.8c030726.jpg";